import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { capatelize } from 'src/app/SEO_Constant/routes.constant';
import { description, keyword } from 'src/app/SEO_Constant/seo';

@Component({
    selector: 'app-logo-design',
    templateUrl: './logo-design.component.html',
    styleUrls: ['./logo-design.component.css'],
    standalone: false
})
export class LogoDesignComponent implements OnInit {
  titles:any;
  bannerArray:any = {
    "bannerTXT" : [
      {
        title: 'The right business cues.',
      },
      {
        title: 'The right typography.',
      },
      {
        title: 'The right trends.',
      },
      {
        title: 'The right shape.',
      },
    ],
    "bannerImg" : {
      "banner": "assets/img/Logo_Design.png",
      "backgroundImg": "assets/img/banner-background.jpg"
    }
  }

  constructor( private title :Title, private router:Router , private meta: Meta ) {
    this.titles = router.url.split('/')[router.url.split('/').length-1].replace(/-/g,' ')
   }

  ngOnInit(): void {
    this.title.setTitle(capatelize(this.titles) +' | Resiliencesoft')

       this.meta.removeTag('name=description');
            this.meta.removeTag('name=keywords');
            this.meta.addTags([
              {
                name: 'description',
                content: description.LogoDesign,
              },
              { name: 'keywords', content: capatelize(keyword.globle) + capatelize(keyword.LogoDesign) },
            ]);
  }

}
